import { Box, IconButton, Textarea, useTheme } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import { MAX_USER_INPUT_CHARS } from '../../config';

const SendIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
  >
    <path
      d='M0 12.8948V1.10529L14 7.00002L0 12.8948ZM1.47368 10.6842L10.2053 7.00002L1.47368 3.31581V5.89476L5.89474 7.00002L1.47368 8.10529V10.6842Z'
      fill='white'
    />
  </svg>
);

const MessageInput = ({ sendMessage, forceDisable, expandedView }) => {
  const theme = useTheme();
  const [message, setMessage] = useState('');
  const inputRef = useRef();

  useEffect(() => {
    if (!forceDisable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [forceDisable]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() !== '') {
      sendMessage(message);
      setMessage('');
    }
  };

  return (
    <Box
      as='form'
      display='flex'
      p={expandedView ? 1 : 1}
      margin={expandedView ? '0px' : '0px 20px 20px 20px'}
      backgroundColor={theme.colors.white}
      borderRadius={expandedView ? '0px' : '6px'}
      boxShadow='0px 0px 15px 0px rgba(0, 0, 0, 0.10)'
      onSubmit={handleSubmit}
      height={55}
      justifyContent='center'
    >
      <Textarea
        autoFocus
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder='Ask us about a symptom, procedure, specialty, doctor...'
        mr={3}
        pt={3}
        pl={2}
        ref={inputRef}
        disabled={forceDisable}
        variant='unstyled'
        onKeyPress={handleKeyPress} // Add this prop
        resize='none' // Optionally, disable resizing if you don't want users to change the size
        maxLength={MAX_USER_INPUT_CHARS}
        fontSize='1rem'
      />
      <IconButton
        // colorScheme="whiteAlpha"
        backgroundColor={theme.colors.gold}
        _hover={{
          backgroundColor: theme.colors.gold,
        }}
        _active={{
          backgroundColor: theme.colors.gold,
        }}
        icon={<SendIcon />}
        disabled={forceDisable}
        aria-label='Send Message'
        type='submit'
        mt={1}
        mr={2}
      />
    </Box>
  );
};

export default MessageInput;
